export default "__VITE_ASSET__ymMlWJoS__"